import {ADMIN_ROUTE_CONSTANTS} from '@shared/constants/routes';
import {MenuItem} from 'primeng/api';

const adminBase = `/${ADMIN_ROUTE_CONSTANTS.path}`;

export const CONFIGURATION: MenuItem = {
  label: ADMIN_ROUTE_CONSTANTS.configuration.data.breadcrumb,
  icon: ADMIN_ROUTE_CONSTANTS.configuration.data.icon,
  hasSubmenu: true,
  expanded: false,
  items: [
    {
      label: ADMIN_ROUTE_CONSTANTS.configuration.generalData.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.configuration.generalData.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.configuration.path}/${ADMIN_ROUTE_CONSTANTS.configuration.generalData.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.configuration.users.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.configuration.users.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.configuration.path}/${ADMIN_ROUTE_CONSTANTS.configuration.users.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.configuration.rolesPermissions.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.configuration.rolesPermissions.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.configuration.path}/${ADMIN_ROUTE_CONSTANTS.configuration.rolesPermissions.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.configuration.communicationTemplates.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.configuration.communicationTemplates.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.configuration.path}/${ADMIN_ROUTE_CONSTANTS.configuration.communicationTemplates.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.configuration.administratorProfile.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.configuration.administratorProfile.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.configuration.path}/${ADMIN_ROUTE_CONSTANTS.configuration.administratorProfile.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.configuration.externalIntegrations.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.configuration.externalIntegrations.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.configuration.path}/${ADMIN_ROUTE_CONSTANTS.configuration.externalIntegrations.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.configuration.resetData.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.configuration.resetData.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.configuration.path}/${ADMIN_ROUTE_CONSTANTS.configuration.resetData.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.configuration.deleteCondominium.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.configuration.deleteCondominium.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.configuration.path}/${ADMIN_ROUTE_CONSTANTS.configuration.deleteCondominium.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.configuration.membership.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.configuration.membership.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.configuration.path}/${ADMIN_ROUTE_CONSTANTS.configuration.membership.path}`
    }
  ]
};
